import Inventory from "../../../../shared/projects/project/inventory/Inventory";
import { PreAccessInventoryTab } from "./components";
import { useInventory } from "./useInventory";

const InventoryPage = (): JSX.Element => {
  const { projectDetails, publicProjectDetails } = useInventory();

  if (projectDetails) {
    return <Inventory />;
  }

  return (
    <PreAccessInventoryTab
      projectUuid={publicProjectDetails?.uuid}
      unitMeasurement={publicProjectDetails?.unitMeasurements?.[0] ?? "Carbon"}
    />
  );
};

export default InventoryPage;
